import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Link2, Upload, ArrowRightLeft, CheckCircle, XCircle, Clock } from 'lucide-react';
import { api } from '../lib/api';

const ACCENT = '#f97316';

interface Connection {
  id: string;
  name: string;
  connector_id: string;
  status: string;
  last_tested?: string;
}

export default function DashboardPage() {
  const [connections, setConnections] = useState<Connection[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get<{ connections: Connection[] }>('/connections')
      .then(data => setConnections(data.connections))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <h2 style={{ fontSize: '1.5rem', fontWeight: 700, margin: '0 0 1.5rem', color: '#111827' }}>Dashboard</h2>

      {/* Quick Actions */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1rem', marginBottom: '2rem' }}>
        <Link to="/connections/new" style={cardStyle}>
          <Link2 size={24} color={ACCENT} />
          <span style={{ fontWeight: 600 }}>New Connection</span>
          <span style={{ fontSize: '0.8rem', color: '#6b7280' }}>Connect an external system</span>
        </Link>
        <Link to="/import" style={cardStyle}>
          <Upload size={24} color={ACCENT} />
          <span style={{ fontWeight: 600 }}>CSV Import</span>
          <span style={{ fontSize: '0.8rem', color: '#6b7280' }}>Upload and import data</span>
        </Link>
        <Link to="/migrations" style={cardStyle}>
          <ArrowRightLeft size={24} color={ACCENT} />
          <span style={{ fontWeight: 600 }}>Migrations</span>
          <span style={{ fontSize: '0.8rem', color: '#6b7280' }}>View migration jobs</span>
        </Link>
      </div>

      {/* Connections */}
      <div style={{ backgroundColor: '#fff', borderRadius: '0.5rem', border: '1px solid #e5e7eb', padding: '1.25rem' }}>
        <h3 style={{ fontSize: '1rem', fontWeight: 600, margin: '0 0 1rem', color: '#111827' }}>Connections</h3>
        {loading ? (
          <p style={{ color: '#6b7280', fontSize: '0.875rem' }}>Loading...</p>
        ) : connections.length === 0 ? (
          <p style={{ color: '#6b7280', fontSize: '0.875rem' }}>No connections yet. <Link to="/connections/new" style={{ color: ACCENT }}>Create one</Link></p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            {connections.map(conn => (
              <div key={conn.id} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', padding: '0.75rem', borderRadius: '0.375rem', border: '1px solid #e5e7eb' }}>
                {conn.status === 'connected' ? (
                  <CheckCircle size={18} color="#10b981" />
                ) : conn.status === 'error' ? (
                  <XCircle size={18} color="#ef4444" />
                ) : (
                  <Clock size={18} color="#6b7280" />
                )}
                <div style={{ flex: 1 }}>
                  <span style={{ fontWeight: 500, fontSize: '0.875rem' }}>{conn.name}</span>
                  <span style={{ fontSize: '0.75rem', color: '#6b7280', marginLeft: '0.5rem' }}>{conn.connector_id}</span>
                </div>
                <span style={{ fontSize: '0.75rem', color: '#6b7280' }}>{conn.status}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

const cardStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0.5rem',
  padding: '1.5rem',
  backgroundColor: '#fff',
  borderRadius: '0.5rem',
  border: '1px solid #e5e7eb',
  textDecoration: 'none',
  color: '#111827',
  textAlign: 'center',
  transition: 'border-color 0.15s',
};
